import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {Configuration} from './configuration';

import {ApplicationRemoteControllerService} from './api/applicationRemoteController.service';
import {FlavorControllerService} from './api/flavorController.service';
import {HistoricalValueControllerService} from './api/historicalValueController.service';
import {MarketHubControllerService} from './api/marketHubController.service';
import {PeriodDivisionControllerService} from './api/periodDivisionController.service';
import {PeriodTypeControllerService} from './api/periodTypeController.service';
import {ProductControllerService} from './api/productController.service';
import {ProductTypeControllerService} from './api/productTypeController.service';
import {DocumentControllerService} from './api/documentController.service';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [],
  exports:      [],
  providers: [
    ApplicationRemoteControllerService,
    FlavorControllerService,
    HistoricalValueControllerService,
    MarketHubControllerService,
    PeriodDivisionControllerService,
    PeriodTypeControllerService,
    ProductControllerService,
    ProductTypeControllerService,
    DocumentControllerService]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        }
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import your base AppModule only.');
        }
    }
}
